module.exports = __webpack_public_path__ + "img/18.0a87ff23.png";